import { RequestPayload, ResponsePayload } from './request';
import { StockArticleEvent } from './customer-article';

export interface CustomerStatistics {
  stock?: CustomerStatisticsStockPayload;
  orders?: StockArticleEvent[];
  shipments?: StockArticleEvent[];
  articleIds?: string[];
  year?: number | null;
  month?: number | null;
  minDate?: string;
  maxDate?: string;
  isZoomedIn?: boolean;
}

export interface CustomerStatisticsStock {
  date: string;
  total: number;
  withdrawals: number;
  confirmed: number;
}

export interface CustomerStatisticsStockPayload {
  [articleId: string | 'all']: CustomerStatisticsStock[];
}

export type CustomerStatisticsOrdersPayload = StockArticleEvent[];

export type CustomerStatisticsShipmentsPayload = StockArticleEvent[];

export type CustomerStatisticsFulfillOrderPayload = StockArticleEvent;

export type CustomerStatisticsConfirmShipmentPayload = StockArticleEvent;

export type CustomerStatisticsConfirmCustomArrivalPayload = StockArticleEvent;

export enum CustomerStatisticsActions {
  FETCH_STATISTICS_STOCK = 'FETCH_STATISTICS_STOCK',
  FETCH_STATISTICS_STOCK_SUCCESS = 'FETCH_STATISTICS_STOCK_SUCCESS',
  FETCH_STATISTICS_ORDERS = 'FETCH_STATISTICS_ORDERS',
  FETCH_STATISTICS_ORDERS_SUCCESS = 'FETCH_STATISTICS_ORDERS_SUCCESS',
  FETCH_STATISTICS_SHIPMENTS = 'FETCH_STATISTICS_SHIPMENTS',
  FETCH_STATISTICS_SHIPMENTS_SUCCESS = 'FETCH_STATISTICS_SHIPMENTS_SUCCESS',
  FULFILL_STATISTICS_ORDER = 'FULFILL_STATISTICS_ORDER',
  FULFILL_STATISTICS_ORDER_SUCCESS = 'FULFILL_STATISTICS_ORDER_SUCCESS',
  CONFIRM_STATISTICS_SHIPMENT = 'CONFIRM_STATISTICS_SHIPMENT',
  CONFIRM_STATISTICS_SHIPMENT_SUCCESS = 'CONFIRM_STATISTICS_SHIPMENT_SUCCESS',
  CONFIRM_CUSTOM_ARTICLE_ARRIVAL = 'CONFIRM_CUSTOM_ARTICLE_ARRIVAL',
  CONFIRM_CUSTOM_ARTICLE_ARRIVAL_SUCCESS = 'CONFIRM_CUSTOM_ARTICLE_ARRIVAL_SUCCESS'
}

export interface CustomerStatisticsActionType<T, P> {
  type: T;
  payload: P;
  asyncDispatch?: any;
}

export type CustomerStatisticsAction =
  | CustomerStatisticsActionType<
    typeof CustomerStatisticsActions.FETCH_STATISTICS_STOCK,
    RequestPayload
  >
  | CustomerStatisticsActionType<
    typeof CustomerStatisticsActions.FETCH_STATISTICS_STOCK_SUCCESS,
    ResponsePayload<CustomerStatisticsStockPayload>
  >
  | CustomerStatisticsActionType<
    typeof CustomerStatisticsActions.FETCH_STATISTICS_ORDERS,
    RequestPayload
  >
  | CustomerStatisticsActionType<
    typeof CustomerStatisticsActions.FETCH_STATISTICS_ORDERS_SUCCESS,
    ResponsePayload<CustomerStatisticsOrdersPayload>
  >
  | CustomerStatisticsActionType<
    typeof CustomerStatisticsActions.FETCH_STATISTICS_SHIPMENTS,
    RequestPayload
  >
  | CustomerStatisticsActionType<
    typeof CustomerStatisticsActions.FETCH_STATISTICS_SHIPMENTS_SUCCESS,
    ResponsePayload<CustomerStatisticsShipmentsPayload>
  >
  | CustomerStatisticsActionType<
    typeof CustomerStatisticsActions.FULFILL_STATISTICS_ORDER,
    RequestPayload
  >
  | CustomerStatisticsActionType<
    typeof CustomerStatisticsActions.FULFILL_STATISTICS_ORDER_SUCCESS,
    ResponsePayload<CustomerStatisticsFulfillOrderPayload>
  >
  | CustomerStatisticsActionType<
    typeof CustomerStatisticsActions.CONFIRM_STATISTICS_SHIPMENT,
    RequestPayload
  >
  | CustomerStatisticsActionType<
    typeof CustomerStatisticsActions.CONFIRM_STATISTICS_SHIPMENT_SUCCESS,
    ResponsePayload<CustomerStatisticsConfirmShipmentPayload>
  >
  | CustomerStatisticsActionType<
    typeof CustomerStatisticsActions.CONFIRM_CUSTOM_ARTICLE_ARRIVAL,
    RequestPayload
  >
  | CustomerStatisticsActionType<
    typeof CustomerStatisticsActions.CONFIRM_CUSTOM_ARTICLE_ARRIVAL_SUCCESS,
    ResponsePayload<CustomerStatisticsConfirmCustomArrivalPayload>
  >;
